import { useMemo } from 'react';

import { TypesWithScore } from '@webapp/common/resources/survey';

import { QuestionsSection } from '@webapp/survey/src/components/questions';
import type { QuestionActorRef } from '@webapp/survey/src/machine/question-machine';

import css from '../test-results.css';

export const Answers: VFC<{
    questions: Array<QuestionActorRef>;
}> = ({ questions }) => {
    const answers = useMemo(
        () =>
            questions.filter((q) => {
                const type = q.getSnapshot().context.type;
                return TypesWithScore.has(type);
            }),
        [questions],
    );

    return (
        <div className={css.questionsWrap}>
            <QuestionsSection readOnly showHeader questions={answers} />
        </div>
    );
};
Answers.displayName = 'Answers';
